import { render, staticRenderFns } from "./CenteredAutoSwiper.vue?vue&type=template&id=8ac686b6&scoped=true"
import script from "./CenteredAutoSwiper.vue?vue&type=script&lang=js"
export * from "./CenteredAutoSwiper.vue?vue&type=script&lang=js"
import style0 from "./CenteredAutoSwiper.vue?vue&type=style&index=0&id=8ac686b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac686b6",
  null
  
)

export default component.exports